import axios from 'axios';
import { useCallback } from 'react';
import { Path, UseFormSetError } from 'react-hook-form';
import { FieldValues } from 'react-hook-form/dist/types/fields';
import { useAppDispatch } from '@shared/hooks/use-app-dispatch.ts';
import { showPopup } from '@src/library/redux/modal/index.ts';

type HandleErrors<T extends FieldValues> = {
  e: unknown;
  setError?: UseFormSetError<T>;
};

export const useErrorsHandler = () => {
  const dispatch = useAppDispatch();

  const handleErrors = useCallback(
    <T extends FieldValues>(props: HandleErrors<T>) => {
      const { e, setError } = props;
      if (axios.isAxiosError(e)) {
        if (e?.response?.data) {
          const errorsData = e?.response?.data;
          if (errorsData) {
            if (errorsData['root']) {
              const errorMessage = Array.isArray(errorsData['root'])
                ? errorsData['root'][0]
                : errorsData['root'];

              if (errorMessage !== 'ValidationError') {
                dispatch(
                  showPopup({
                    type: 'error',
                    text: errorMessage,
                  })
                );
              }
            }

            setError &&
              Object.keys(errorsData).forEach((key) => {
                if (key !== 'root') {
                  const error = Array.isArray(errorsData[key])
                    ? errorsData[key][0]
                    : errorsData[key];
                  setError(key as Path<T>, { message: error, type: 'manual' });
                }
              });
          }
        }
      }
    },
    [dispatch]
  );
  return {
    handleErrors,
  };
};
